import { useMutation } from '@/react-query/hooks/useMutation/useMutation';
import { groupQueries } from '@/services/groupsManagement/groupsManagement.queries';
import { revalidate } from '@/services/revalidate/revalidate';
import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

export const useUpdateGroupStatus = () => {
  const queryClient = useQueryClient();
  const { mutateAsync, isPending } = useMutation('updateGroupStatus', {
    onSuccess: async (res) => {
      await queryClient.invalidateQueries({ queryKey: groupQueries.all() });
      toast.success(res.message);
      await revalidate(['searchGroups', 'all']);
    },
    onError: (error) => {
      toast.error(error.message);
    },
  });

  return { mutateAsync, isPending };
};
